enum DateFormatEnum {
    ISO_DATE = "YYYY-MM-DD",
    ISO_TIME = "HH:mm",
    ISO_DATE_TIME = "YYYY-MM-DD HH:mm",
    ISO_DATE_TIME_SECONDS = "YYYY-MM-DD HH:mm:ss",
    ISO_MONTHYEAR = "MMYYYY",
    ITA_DATE = "DD/MM/YYYY",
    ITA_TIME = "HH:mm",
    ITA_DATE_TIME = "DD/MM/YYYY HH:mm",
    ITA_DATE_TIME_SECONDS = "DD/MM/YYYY HH:mm:ss",
    ITA_MONTHYEAR = "MM/YYYY",
    JS_ITA_DATE = "dd/MM/yyyy",
}

export default DateFormatEnum;
